<template>
  <div class="pa-5">
    <v-row class="ma-0 pa-0">
      <v-col class="mb-5">
        <p class="caption">
          {{ $t('common.roles.owner') }}
        </p>
        <User
          :account="owner"
          :organizationId="organizationId"
          :name="name"
          :userId="owner._id"
        />
      </v-col>
    </v-row>

    <v-row class="ma-0 pa-0">
      <v-col class="mb-5">
        <p class="caption">
          {{ $t('common.date.start_date') }}
        </p>
        <div class="d-flex">
          <v-icon>mdi-calendar-outline</v-icon>
          <p class="body-2 mb-0 ms-1">
            {{ toHumanDistanceToNow(challenge.startAt) }}
          </p>
        </div>
      </v-col>

      <v-col class="mb-5">
        <p class="caption">
          {{ $t('common.date.end_date') }}
        </p>
        <div class="d-flex">
          <v-icon>mdi-calendar-outline</v-icon>
          <p class="body-2 mb-0 ms-1">
            {{ toHumanDistanceToNow(challenge.endAt) }}
          </p>
        </div>
      </v-col>
    </v-row>

    <v-row v-if="challenge.description" class="ma-0 pa-0">
      <v-col class="mb-5">
        <p class="caption">
          {{ $t('challenge.description') }}
        </p>
        <p class="body-2 mb-0 pre-line">{{ challenge.description }}</p>
      </v-col>
    </v-row>

    <v-row v-if="challenge.sites" class="ma-0 pa-0">
      <v-col class="mb-5">
        <p class="caption">
          {{ $t('common.site_other') }}
        </p>
        <v-chip
          v-for="site in challenge.sites"
          outlined
          small
          class="mb-2 me-2 label"
          :key="site._id"
          >{{ site.name }}</v-chip
        >
      </v-col>
    </v-row>

    <v-row v-if="challenge.tags && challenge.tags.length" class="ma-0 pa-0">
      <v-col class="mb-5">
        <p class="caption">
          {{ $t('common.attribute_other') }}
        </p>
        <v-chip
          v-for="tag in challenge.tags"
          outlined
          small
          class="mb-2 me-2 label"
          :key="tag.name"
          >{{ tag.name }}</v-chip
        >
      </v-col>
    </v-row>

    <v-row
      v-if="challenge.categories && challenge.categories.length"
      class="ma-0 pa-0"
    >
      <v-col class="mb-5">
        <p class="caption">
          {{ $t('common.category_other') }}
        </p>
        <v-chip
          v-for="(category, index) in challenge.categories"
          outlined
          small
          class="mb-2 me-2 label"
          :key="category + index"
          >{{ $t(`common.categories.${category}`) }}</v-chip
        >
      </v-col>
    </v-row>
    <v-row v-if="challenge.KPIs" class="ma-0 pa-0">
      <v-col class="mb-5">
        <p class="caption">
          {{ $t('challenge.kpi') }}
        </p>
        <p>{{ challenge.KPIs }}</p>
      </v-col>
    </v-row>

    <v-row v-if="challenge.rewardsText" class="ma-0 pa-0">
      <v-col class="mb-5">
        <p class="caption">
          {{ $t('challenge.rewards') }}
        </p>
        <p>{{ challenge.rewardsText }}</p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import User from '@/components/Core/User.vue'
import userMixin from '@/mixins/userMixin.vue'

import { utils } from 'frontend-js-shared'

export default {
  name: 'ChallengeSummary',

  mixins: [userMixin],

  components: {
    User,
  },

  props: {
    challenge: {
      type: Object,
      required: true,
    },
  },

  computed: {
    organizationId() {
      return this.challenge?.organization?._id
    },

    owner() {
      return this.challenge?.account ?? {}
    },

    name() {
      return this.getFullName(this.owner)
    },
  },

  methods: {
    toHumanDistanceToNow(date) {
      return utils.dates.toHumanDistanceToNow(date)
    },
  },
}
</script>
